export const globalVar = [{
    dzien: "13",
    miesiac: "04",
    rok: "2025",
    niedziela: "VI NIEDZIELA WIELKIEGO POSTU - PALMOWA (MĘKI PAŃSKIEJ) 13.04.2025",

}]